module.exports = __webpack_public_path__ + "img/barring.df446cb6.jpg";